import Popup from '../components/popup/index';
import { connect } from 'react-redux';
import { showPopup } from './actions';

const mapStateToPropsRes = (state) => {


  return {
    id: 'mapPopup',
  	items: state.popup.items,
  //  title: state.contextmenu.address
  };
};

const mapDispatchToPropsRes = (dispatch) => {

  return {
    clickHandler: (ev, data) => {

    //  var coord = map.getCoordinateFromPixel(data);

      dispatch(showPopup(null));

      return;
    },
    closeHandler: (ev, data) => {
      
      dispatch(showPopup(null));
    }
  };
};

const mapPopupContainer = connect(
  mapStateToPropsRes,
  mapDispatchToPropsRes
)(Popup);

export default mapPopupContainer;